import type { UserRoleEnum } from '@/modules/core/models/enums'
import PetQuotation from './PetQuotation'

/** Objeto que contiene información sobre la contratación. Para rater */

export default class PetsSaveQuotationHiring {
  /** (Integer): Número de la cotización, entero de 32 bits. */
  quotationNumber!: number

  /** (Integer): Forma de pago. */
  billingCycle!: number

  /** (Integer): Código del cliente. */
  clientCode!: number

  /** (Integer): Código del producto. */
  productCode!: number

  /** (String): Línea de negocio. */
  businessLine!: string

  /** (Datetime): Fecha de inicio del seguro. */
  insuranceStartDate!: number

  /** (string): Rol del titular. */
  role?: UserRoleEnum | undefined

  pets: PetQuotation[]

  constructor(data: any) {
    this.quotationNumber = data.quotationNumber
    this.billingCycle = data.billingCycle
    this.clientCode = data.clientCode
    this.productCode = data.productCode
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.role = data.role
    this.pets = data.pets?.map((pet: any) => new PetQuotation(pet))
  }
}
